/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const RestorePraetorVersionBody = zod
	.object({
		version_id: zod.uuid().describe('Version ID to restore')
	})
	.describe('Request body for restoring a praetor version');

export type RestorePraetorVersionBody = zod.input<typeof RestorePraetorVersionBody>;
export type RestorePraetorVersionBodyOutput = zod.output<typeof RestorePraetorVersionBody>;
